import { useState } from 'react'
import styles from './avatar.module.css'

type Props = {
  src: string | null | undefined
  name: string | null | undefined
  size?: number
  ring?: boolean
  className?: string
}

export function Avatar({ src, name, size = 56, ring = false, className }: Props) {
  const [failedSrc, setFailedSrc] = useState<string | null>(null)
  const initial = (name?.trim() || 'Л').charAt(0).toUpperCase()
  const photo = src && src !== failedSrc ? src : null
  const cls = [styles.avatar, ring ? styles.ring : '', className ?? ''].filter(Boolean).join(' ')
  return (
    <span className={cls} style={{ width: size, height: size, fontSize: Math.round(size * 0.43) }} aria-hidden="true">
      {photo ? (
        <img className={styles.photo} src={photo} alt="" width={size} height={size} onError={() => setFailedSrc(photo)} />
      ) : (
        <span className={styles.initial}>{initial}</span>
      )}
    </span>
  )
}
